import { render, staticRenderFns } from "./4-abatement.vue?vue&type=template&id=0e934975&"
import script from "./4-abatement.vue?vue&type=script&lang=js&"
export * from "./4-abatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports